<template>
  <v-form ref="form">
    <v-container class="limited" grid-list-xl>
      <v-layout row wrap fill-height>
        <v-flex xs12>
          <v-card class="pa-4 elevation-5" column height="100%">
            <v-flex xs12>
              <v-layout column>
                <v-layout row wrap align-center justify-space-between="">
                  <h4 class="subheading font-weight-black primary--text pl-2">
                    Movimento
                  </h4>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md4 class="py-0">
                    <v-text-field
                      name="id"
                      label="ID Movimento"
                      type="text"
                      v-model="movimento.id"
                      required
                      :disabled="true"
                      data-cy="idField"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 class="py-0">
                    <v-text-field
                      name="dataCriacao"
                      label="Data de Criação"
                      type="text"
                      v-model="movimento.dataCriacao"
                      required
                      v-mask="'##/##/####'"
                      :masked="true"
                      :disabled="true"
                      data-cy="dataCriacaoField"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 class="py-0">
                    <v-text-field
                      name="status"
                      label="Status"
                      type="text"
                      v-model="movimento.status"
                      required
                      :disabled="true"
                      data-cy="cpfField"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 class="py-0">
                    <v-text-field
                      name="nome"
                      label="Nome Completo"
                      type="text"
                      v-model="movimento.nome"
                      required
                      :disabled="true"
                      data-cy="nomeField"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 class="py-0">
                    <v-text-field
                      name="cpf"
                      label="Número do cartão"
                      type="text"
                      v-model="movimento.numeroCartao"
                      required
                      :disabled="true"
                      data-cy="cpfField"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 class="py-0">
                    <v-text-field
                      name="comunicado"
                      label="Tipo de Comunicado"
                      type="text"
                      :value="
                        movimento.tipoEnvioComunicado === 'C'
                          ? 'Correspondência'
                          : 'E-mail'
                      "
                      required
                      :disabled="true"
                      data-cy="cpfField"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="pa-4 elevation-5" column>
            <v-flex xs12>
              <v-layout column>
                <h4 class="subheading font-weight-black primary--text">
                  Beneficiário Selecionados
                </h4>
                <v-list
                  three-line
                  v-if="movimento.exclusaoBeneficiarioSelecionados"
                >
                  <template
                    v-for="(item,
                    index) in movimento.exclusaoBeneficiarioSelecionados"
                  >
                    <v-list-tile v-if="item" :key="item.id" ripple>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{ item.nomeBeneficiario }} ({{
                            item.numeroCartao || item.beneficiario
                          }})</v-list-tile-title
                        >
                        <v-list-tile-sub-title
                          class="text--primary"
                          v-if="item.motivoExclusao"
                          >Motivo:
                          {{
                            item.motivoExclusao
                              ? item.motivoExclusao.descricao
                              : ""
                          }}</v-list-tile-sub-title
                        >
                        <v-list-tile-sub-title
                          class="text--primary"
                          v-if="
                            item.motivoExclusao &&
                              item.motivoExclusao.id ===
                                '00000000-0000-0000-0000-000000000003'
                          "
                          >Motivo Óbito:
                          {{
                            item.motivoObito ? item.motivoObito.descricao : ""
                          }}</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider
                      v-if="
                        index + 1 <
                          movimento.exclusaoBeneficiarioSelecionados.length
                      "
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="movimento.solicitouExclusaoRh">
          <v-card class="pa-4 elevation-5" column>
            <v-flex xs12>
              <v-layout column>
                <h4 class="subheading font-weight-black primary--text">
                  Exclusão de Planos Coletivos
                </h4>
                <v-layout row wrap>
                  <v-flex xs12 md6 lg3 class="py-0">
                    <v-text-field
                      label="Qual a data que foi solicitada a exclusão?"
                      type="text"
                      v-model="movimento.dataSolicitacaoRh"
                      :disabled="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 lg3 class="py-0">
                    <v-text-field
                      label="Qual o nome da pessao que você solicitou a exclusão?"
                      type="text"
                      v-model="movimento.nomePessoaSolicExclusao"
                      :disabled="true"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="movimento.tipoEnvioComunicado === 'C'">
          <v-card class="pa-4 elevation-5" column>
            <v-flex xs12>
              <v-layout column>
                <h4 class="subheading font-weight-black primary--text mb-3">
                  Endereço
                </h4>
                <template v-for="(endereco, index) in enderecos">
                  <v-layout column :key="index" class="ma-1 mb-5">
                    <v-layout row wrap>
                      <v-flex xs12 md4 lg3 class="py-0">
                        <v-text-field
                          required
                          v-model="endereco.tipoEndereco.descricao"
                          :disabled="true"
                          type="text"
                          label="Tipo"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg3 class="py-0">
                        <v-text-field
                          name="cep"
                          label="CEP"
                          type="text"
                          v-model="endereco.cep"
                          :disabled="true"
                          required
                          data-cy="cepField"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg4 class="py-0">
                        <v-text-field
                          name="street"
                          label="Rua"
                          type="text"
                          v-model="endereco.logradouro"
                          :disabled="true"
                          required
                          data-cy="streetField"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg2 class="py-0">
                        <v-text-field
                          name="number"
                          label="Número"
                          type="text"
                          :disabled="true"
                          v-model="endereco.numero"
                          required
                          data-cy="numberField"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg4 class="py-0">
                        <v-text-field
                          name="district"
                          label="Bairro"
                          type="text"
                          :disabled="true"
                          v-model="endereco.bairro"
                          required
                          data-cy="districtField"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg4 class="py-0">
                        <v-text-field
                          name="city"
                          label="Cidade"
                          type="text"
                          :disabled="true"
                          v-model="endereco.cidade"
                          required
                          data-cy="cityField"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg1 class="py-0">
                        <v-text-field
                          name="state"
                          label="Estado"
                          type="text"
                          :disabled="true"
                          v-model="endereco.uf"
                          required
                          data-cy="stateField"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg3 class="py-0">
                        <v-text-field
                          name="complement"
                          label="Complemento"
                          type="text"
                          :disabled="true"
                          v-model="endereco.complemento"
                          required
                          data-cy="complementField"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg3 class="py-0">
                        <v-text-field
                          name="caixaPostal"
                          label="Caixa Postal"
                          type="text"
                          :disabled="true"
                          v-model="endereco.caixaPostal"
                          required
                          data-cy="caixaPostalField"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg3 class="py-0">
                        <v-text-field
                          name="pontoReferencia"
                          label="Ponto de referência"
                          type="text"
                          :disabled="true"
                          v-model="endereco.pontoReferencia"
                          required
                          data-cy="pontoReferenciaField"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg6>
                        <h5 class="subheading">
                          Quando necessário, é neste endereço que gostaria de:
                        </h5>
                        <v-layout row wrap>
                          <div
                            v-for="(finalidade,
                            indexFinalidade) in endereco.finalidades"
                            :key="indexFinalidade"
                            class="mr-3"
                          >
                            <v-checkbox
                              :key="indexFinalidade"
                              v-model="
                                endereco.finalidades[indexFinalidade]
                                  .selecionado
                              "
                              :label="finalidade.descricao"
                              :disabled="true"
                              color="primary"
                              hide-details
                            />
                          </div>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-divider
                      v-if="index + 1 < enderecos.length"
                      :key="index"
                    ></v-divider>
                  </v-layout>
                </template>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="movimento.tipoEnvioComunicado === 'E'">
          <v-card class="pa-4 elevation-5" column>
            <v-flex xs12>
              <v-layout column>
                <h4 class="subheading font-weight-black primary--text">
                  Contato
                </h4>
                <v-layout row wrap>
                  <v-flex xs12 md6 lg3 class="py-0">
                    <v-text-field
                      name="phone"
                      label="Telefone"
                      type="text"
                      :disabled="true"
                      v-model="contatoTelefone.contato"
                      required
                      data-cy="phoneField"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 lg3 class="py-0">
                    <v-text-field
                      name="cellPhone"
                      label="Celular"
                      type="text"
                      :disabled="true"
                      v-model="contatoCelular.contato"
                      required
                      data-cy="cellPhoneField"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6 lg3 class="py-0">
                    <v-text-field
                      name="email"
                      label="E-mail"
                      type="text"
                      :disabled="true"
                      v-model="contatoEmail.contato"
                      required
                      data-cy="emailField"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="pa-4 elevation-5" column>
            <v-flex xs12>
              <v-layout column>
                <h4 class="subheading font-weight-black primary--text">
                  Anexos
                </h4>
                <v-data-table
                  :headers="headers"
                  :items="movimentoAnexos"
                  :pagination.sync="pagination"
                  :total-items="movimentoAnexos.length"
                  :loading="isLoading"
                  :rows-per-page-items="[5, 10, 25]"
                  no-data-text="Não há registros"
                  rows-per-page-text="Linhas por página"
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.anexo.filename }}</td>
                    <td>{{ props.item.tipoAnexo.descricao }}</td>
                    <td>
                      <v-btn
                        flat
                        small
                        color="green"
                        @click="
                          downloadMovimentoAnexo(props.item.anexo.arquivoId)
                        "
                        >Baixar</v-btn
                      >
                    </td>
                  </template>
                </v-data-table>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="movimento.observacoes">
          <v-card class="pa-4 elevation-5" column>
            <v-flex xs12>
              <v-layout column>
                <h4 class="subheading font-weight-black primary--text">
                  Observações
                </h4>
                <v-layout row wrap>
                  <v-flex class="py-0">
                    <v-text-field
                      type="text"
                      disabled
                      v-model="movimento.observacoes"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
      <loading-dialog
        :show="isLoading"
        :message="loadingMessage"
      ></loading-dialog>
    </v-container>
  </v-form>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { mask } from "vue-the-mask";

import { formataData } from "@/utils/formataValores";

import LoadingDialog from "@/components/LoadingDialog";

import {
  getExclusoesSolicitadasBeneficiario,
  listarMovimentoAnexos,
  downloadAnexoMovimento
} from "@/services/movimentos";

import { download } from "@/utils/download";

const { mapState } = createNamespacedHelpers("beneficiario");
const { mapMutations } = createNamespacedHelpers("portal");

export default {
  name: "UpdateRegistration",
  directives: { mask },
  components: {
    LoadingDialog
  },
  computed: mapState(["dadosBeneficiario"]),
  data() {
    return {
      isLoading: false,
      loadingMessage: null,
      enderecos: [],
      movimentoAnexos: [],
      pessoal: {
        nome: "",
        dataNascimento: "",
        cpf: "",
        nomeMae: ""
      },
      contatoCelular: {
        id: null,
        tipoContato: {
          id: "00000000-0000-0000-0000-000000000001",
          descricao: "Celular"
        },
        contato: ""
      },
      contatoTelefone: {
        id: null,
        tipoContato: {
          id: "00000000-0000-0000-0000-000000000002",
          descricao: "Telefone Fixo"
        },
        contato: ""
      },
      contatoEmail: {
        id: null,
        tipoContato: {
          id: "00000000-0000-0000-0000-000000000003",
          descricao: "E-mail"
        },
        contato: ""
      },
      movimento: {},
      headers: [
        { text: "Nome do Arquivo", value: "nomeArquivo", sortable: false },
        { text: "Tipo", value: "tipo", sortable: false },
        {
          text: "",
          value: "downloadId",
          sortable: false,
          align: "center"
        }
      ]
    };
  },
  created() {
    this.exclusoesSolicitadasBeneficiario();
  },
  methods: {
    ...mapMutations(["setErrorToast", "setToast"]),
    async exclusoesSolicitadasBeneficiario() {
      const movimentoId = this.$route.params.id;

      this.isLoading = true;

      await getExclusoesSolicitadasBeneficiario(movimentoId)
        .then(({ data, errors }) => {
          if (errors && errors.length) {
            const errorMessage = errors[0].message.split(": ")[1];

            this.setErrorToast(errorMessage);
          } else {
            const exclusao = data.exclusoesSolicitadasBeneficiario?.content[0];

            if (exclusao) {
              if (exclusao.codigoBeneficiario === this.dadosBeneficiario.id) {
                const movimento = { ...exclusao };

                let dataSolicitacaoRh;

                if (movimento.dataSolicitacaoRh) {
                  dataSolicitacaoRh = formataData(
                    movimento.dataSolicitacaoRh,
                    "DD/MM/YYYY"
                  );
                }

                this.movimento = {
                  ...movimento,
                  beneficiario: movimento.codigoBeneficiario,
                  dataCriacao: formataData(movimento.dataCriacao, "DD/MM/YYYY"),
                  nome: movimento.nomeBeneficiario,
                  observacoes: movimento.observacoesSolicitante,
                  status: movimento?.statusMovimento?.descricao,
                  dataSolicitacaoRh
                };

                if (movimento.movimentoEndereco) {
                  this.enderecos = movimento.movimentoEndereco;
                }

                for (let index = 1; index <= 3; index++) {
                  const contatos = movimento.movimentoContatos.find(
                    contato =>
                      contato.tipoContato.id ===
                      "00000000-0000-0000-0000-00000000000" + index
                  );
                  if (contatos) {
                    if (index === 1) {
                      this.contatoCelular = contatos;
                    } else if (index === 2) {
                      this.contatoTelefone = contatos;
                    } else if (index === 3) {
                      this.contatoEmail = contatos;
                    }
                  }
                }

                this.listarMovimentoAnexos();
              } else {
                this.setToast(
                  "Você não tem permissão para acessar esse movimento"
                );
              }
            }
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async listarMovimentoAnexos() {
      const movimentoId = this.$route.params.id;
      await listarMovimentoAnexos(movimentoId).then(response => {
        this.movimentoAnexos = response;
      });
    },
    downloadMovimentoAnexo(movimentoArquivoId) {
      if (movimentoArquivoId === null) {
        this.setToast("Anexo do movimento indisponível para download");
      } else {
        downloadAnexoMovimento(movimentoArquivoId).then(({ headers, data }) => {
          if (data?.error) {
            const errorMessage = data.message;

            this.setErrorToast(errorMessage);
          } else {
            const filename = headers["content-disposition"].replace(
              "attachment; filename=",
              ""
            );

            download(data, filename);
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.container.grid-list-xs .layout .flex {
  padding: 1px !important;
}
</style>
